import { configureStore } from "@reduxjs/toolkit";
import themeReducer from "../features/themeSlice";
import chatReducer from "../features/chatSlice";
import modalReducer from "../features/modalSlice";
import authReducer from "../features/auth/authSlice";
import folderReducer from "../features/folderSlice"; // Import the folder slice
import forgotPasswordReducer from "../features/auth/forgotPasswordSlice";  // Import the forgotPassword slice
import pinReducer from "../features/pinSlice";  // Import the forgotPassword slice
import searchReducer from '../features/searchSlice'; // Import the search reducer
import sidebarFolderReducer from '../features/sidebarFolderSlice'; // Import the search reducer
import sidebarChatReducer from '../features/sidebarChatSlice'; // Import the search reducer


// Configure the Redux store
export const store = configureStore({
  reducer: {
    theme: themeReducer,
    chat: chatReducer,
    modal: modalReducer,
    auth: authReducer,
    forgotPassword: forgotPasswordReducer,
    folders: folderReducer, // Adding folderSlice to the store
    pin: pinReducer, // Register pin slice
    search: searchReducer,
    sidebarFolders: sidebarFolderReducer,
    sidebarChats: sidebarChatReducer,


  },
});

// Export RootState and AppDispatch types for TypeScript
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
